<!-- data driven dashboard-->
<section *ngIf="(vm$ | async) as vm">

  <app-page-loader [vm]="vm"></app-page-loader>

  <div *ngIf="!vm.workingText && !vm.errorText">

    <!-- deployment type - external -->
    <div *ngIf="vm.deploymentContext.external">
      <div class="jumbotron">
        <h1 class="display-4">{{vm.data.external.title}}</h1>
        <!-- <p class="lead">
                Some welcome text...
            </p> -->
        <hr class="my-4">
        <div class="row">
          <div class="col-md-12 text-center" *ngIf="vm.powerBiReportVm">
            <app-ecls-power-bi-report [powerBiReportVm]="vm.powerBiReportVm"></app-ecls-power-bi-report>
          </div>
        </div>

      </div>
    </div>

    <!-- deployment type - customer -->
    <div *ngIf="vm.deploymentContext.customer">
      <div class="jumbotron">
        <h1 class="display-4">EmpireCLS Chauffeur Dashboard</h1>
        <!-- <p class="lead">
                    Some welcome text...
                </p> -->
        <hr class="my-4">
        <div class="row">
          <div class="col-md-8 text-center">
            <div *ngIf="vm.data.customer as cd">
              <h5>{{cd.title}}</h5>
              <table class="table no-header table-fixed table-borderless" mdbTable small="true"
                *ngIf="cd.status == 'ok'">
                <thead>
                  <tr mdbTableCol>
                    <th class=" text-center" *ngFor="let c of cd.columns">{{c}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr mdbTableCol *ngFor="let r of cd.rows">
                    <td *ngFor="let f of r">
                      <span>{{f}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-4 text-center">
            <app-form-button color="primary" size="lg" [rounded]="true" title="View Manifest"
              (click)="customerAction(vm, 'manifest')"></app-form-button>
          </div>
        </div>

      </div>

    </div>

    <!-- deployment type - internal-->
    <div *ngIf="vm.deploymentContext.internal">
      <div class="row">
        <div class="col-md-2">
          <div class="switch">
            <label>
              Off
              <input type="checkbox" [(ngModel)]="vm.refreshEnabled">
              <span class="lever"></span> On
            </label>
          </div>
        </div>
        <div class="col-md-10">
          <div *ngIf="vm.refreshWorkingText">
            <span>{{vm.refreshWorkingText}}</span>
          </div>
          <div *ngIf="vm.refreshErrorText" class="text-danger">
            <span>{{vm.refreshErrorText}}</span>
          </div>
          <div *ngIf="vm.refreshCompletedDateTime">
            <span>Last updated: {{vm.refreshCompletedDateTime | date:'shortTime'}}</span>
          </div>
        </div>
      </div>

      <div class="row">

        <div class="col-md-12 text-center" *ngIf="!vm.data.panels.length">
          <div>
            <span class="h3-responsive">There's nothing for you to see here, please move along!</span>
          </div>
          <div>
            <span>If you were expecting to see something here please contact the IT department.</span>
          </div>
        </div>

        <div class="col-md-4 pb-3" *ngFor="let p of vm.data.panels">

          <mdb-card narrower="true" cascade="true">
            <app-card-header [title]="p.title" [headingSize]="3" [fullHeader]="true"
              [subTitle]="p.lastUpdated | date:'short'"></app-card-header>
            <mdb-card-body cascade="true">
              <div class="row">
                <div class="col-xl-12 col-md-12 col-lg-12 mr-0">
                  <div class="card-body card-body-cascade">
                    <div class="row">
                      <table class="table no-header table-fixed table-borderless" mdbTable small="true">
                        <tbody>
                          <tr *ngFor="let i of p.items">
                            <td class="th-lg">
                              <h6>{{i.stat}}</h6>
                            </td>
                            <td
                              [ngClass]="{ 'text-danger': i.alertLevel == 'dgr', 'test-warning': i.alertLevel == 'wrn' }">
                              {{i.value}}
                            </td>
                          </tr>
                          <tr *ngFor="let i of p.items | slice:0: 4-p.items.length;">
                            <td class="th-lg">
                              <h6>&nbsp;</h6>
                            </td>
                            <td></td>
                          </tr>
                          <tr class="text-center text-danger" *ngIf="p.error">
                            <td colspan="2"><span>{{p.error}}</span></td>
                          </tr>
                          <tr class="text-center" *ngIf="p.clientRoute">
                            <td colspan="2">
                              <a class="text-info" [routerLink]="[p.clientRoute]">View
                                Details...</a>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </mdb-card-body>
          </mdb-card>

        </div>
      </div>

    </div>

    <!-- deployment type - chauffeur -->
    <div *ngIf="vm.data.chauffeur as c">
      <div class="jumbotron">
        <h3 class="display-5">Welcome '{{c.driverInfo.name}} ({{c.driverInfo.code}})'</h3>
        <hr class="my-4">
        <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'">
          <mdb-tab heading="Time Clock" *ngIf="c.driverInfo.showTimeClockTab" [attr.data-id]="1">
            <div class="row">
              <div class="col-md-12 text-center">
                <app-payroll-break></app-payroll-break>
              </div>
            </div>
          </mdb-tab>
          <mdb-tab heading="Payroll" *ngIf="c.driverInfo.showPayrollTab" [attr.data-id]="1">
            <div class="row">
              <div class="col-md-8 text-center">
                <app-payroll-compare-card [vm]="c.payrollInfo.payrollCompareVm">
                </app-payroll-compare-card>
              </div>
              <div class="col-md-4 text-center">
                <mdb-card narrower="true" cascade="true">
                  <app-card-header [title]="'Reviews'" [headingSize]="3" [fullHeader]="true"></app-card-header>
                  <mdb-card-body cascade="true">
                    <div class="text-center">
                      Average rating is '{{c.reviewInfo.average | number:'1.2-2'}}' from {{c.reviewInfo.count}} survey(s).
                    </div>
                    <div class="text-center">
                      {{c.reviewInfo.missing}} survey(s) didn't have a rating.
                    </div>
                    <div class="text-center">
                      Last survey received on {{c.reviewInfo.lastDate}}.
                    </div>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </div>
            <div class="row" *ngIf="c.driverInfo?.showTimeClockTab">
              <div class="col-md-12 text-center pt-4">
                <app-payroll-timesheets></app-payroll-timesheets>
              </div>
            </div>
          </mdb-tab>
        </mdb-tabset>
      </div>
    </div>

  </div>

</section>